import { render, staticRenderFns } from "./InvolvedPartiesList.vue?vue&type=template&id=796a246c&scoped=true"
import script from "./InvolvedPartiesList.vue?vue&type=script&lang=ts"
export * from "./InvolvedPartiesList.vue?vue&type=script&lang=ts"
import style0 from "./InvolvedPartiesList.vue?vue&type=style&index=0&id=796a246c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a246c",
  null
  
)

export default component.exports